import axios from './axios'

class Member {
  // 用户信息
  getUserInfo(params, viewState) {
    return axios({
      url: '/account/member/MemberUserInfo',
      method: 'post',
      headers: {
        'Ykt-ViewState': viewState
      },
      data: params
    })
  }
  // 获取会员信息
  getMemberPermission(params, viewState) {
    return axios({
      url: '/account/member/permission',
      method: 'post',
      headers: {
        'Ykt-ViewState': viewState
      },
      data: params
    })
  }
}

export default new Member()
